export default __webpack_public_path__ + "static/media/3.60d13a90.jpg";